import { jsx as _jsx } from "react/jsx-runtime";
import { Interstitial } from '@interstate/components/Interstitial';
import { useSelector } from 'react-redux';
import { dashboardTimeFieldsSelector, dateRangeSelector, selectedDashboardSelector, } from '../components/LandingPageHeader/LandingPageHeader';
import { dashboardsIdReceivedSelector } from '../state/dashboardIdState';
import { organizationSelector } from '../state/orgIdState';
import { USER_HAS_NO_DASHBOARDS } from '../utils/constants';
import LogiComponent from './logi-component/LogiComponent';
import NoDashboard from './NoDashboard';
import './LogiView.scss';
const LogiView = () => {
    const dateRange = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    const selectedDashboard = useSelector(selectedDashboardSelector);
    const dashboardTimeFieldsMap = useSelector(dashboardTimeFieldsSelector);
    const dashboardsIdReceived = useSelector(dashboardsIdReceivedSelector);
    return (_jsx("section", { id: "logi-view", children: _jsx("div", { id: "logi-component-container", children: selectedDashboard === USER_HAS_NO_DASHBOARDS ? (_jsx(NoDashboard, {}))
                : !dashboardsIdReceived ? (_jsx(Interstitial, {})) : (_jsx(LogiComponent, { componentConfig: {
                        dashboardId: selectedDashboard,
                        dateFields: dashboardTimeFieldsMap[selectedDashboard],
                    }, dateRange: dateRange, orgId: orgId }, selectedDashboard)) }) }));
};
export default LogiView;
